export const WEEK_DAYS = <const>[
  'date.weeks.sunday',
  'date.weeks.monday',
  'date.weeks.tuesday',
  'date.weeks.wednesday',
  'date.weeks.thursday',
  'date.weeks.friday',
  'date.weeks.saturday',
];
